<template>
  <div class="c-box-chart">
    <c-box
      :title="title"
      :loading="loading"
    >
      <div
        v-if="!loading && !hasData"
        class="no-data-wrapper"
      >
        <no-data />
      </div>
      <c-line-chart
        v-if="type.toLowerCase() === 'line'"
        :chart-data="chartData"
        :options="chartOptions"
        :style="{ height: `${height}px` }"
        class="line-chart"
      />
      <c-bar-chart
        v-else
        :chart-data="chartData"
        :options="chartOptions"
        :style="{ height: `${height}px` }"
        class="bar-chart"
      />
    </c-box>
  </div>
</template>

<script>
import CBarChart from './CBarChart.vue'
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import CLineChart from './CLineChart.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import pastelRainbowColors from '../../mixins/pastelRainbowColors'

export default {
  name: 'CBoxChart',
  components: {
    CBarChart,
    CBox,
    CLineChart,
    NoData
  },
  mixins: [pastelRainbowColors],
  props: {
    color: {
      type: String,
      default: '#808080'
    },
    data: {
      type: Object,
      default: () => {
        return {
          labels: [],
          charts: []
        }
      }
    },
    fill: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 120
    },
    loading: {
      type: Boolean,
      default: false
    },
    smooth: {
      type: Boolean,
      default: false
    },
    stepX: {
      type: Number,
      default: 0
    },
    stepY: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'bar'
    }
  },
  computed: {
    chartData () {
      const datasets = []
      const defaultOptions = {
        backgroundColor: this.color,
        borderColor: this.color,
        fill: this.fill
      }
      if (this.type === 'line' && !this.smooth) {
        defaultOptions.lineTension = 0
      }
      if (this.data.charts && this.data.charts.length > 0) {
        this.data.charts.forEach((item, index) => {
          const options = Object.assign({}, defaultOptions)
          if (this.data.labels && this.data.labels.length > 0) {
            options.label = this.data.labels[index]
          }
          if (item.length > 0) {
            options.data = item.map(i => ({ x: i.date, y: i.value }))
          }
          datasets.push(options)
        })
      }
      return {
        datasets
      }
    },
    chartOptions () {
      return {
        animation: {
          animateScale: true,
          animateRotate: true
        },
        legend: {
          display: false
        },
        // legend: {
        //   display: true,
        //   position: 'bottom'
        // },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'week',
              tooltipFormat: 'DD MMMM YYYY',
              displayFormats: {
                week: 'DD.MM'
              }
            },
            gridLines: {
              display: false,
              drawBorder: false
            },
            ticks: {
              stepSize: this.stepX
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              drawBorder: false
            },
            ticks: {
              beginAtZero: true,
              stepSize: this.stepY
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    },
    hasData () {
      const charts = this.data.charts
      const hasCharts = charts && charts.length > 0
      return hasCharts
        ? charts.some(item => {
          return Object.prototype.toString.call(item) === '[object Array]' && item.length > 0
        })
        : false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-box-chart {
  .box {
    position: relative;
    .no-data-wrapper {
      margin-bottom: 5px;
      text-align: center;
    }
  }
}
</style>
